import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { toast } from "react-toastify";

const SupplierInfo = ({ asset }) => {
  const [manufacturerId, setManufacturerId] = useState("");
  const [supplierId, setSupplierId] = useState("");
  const [outsourceId, setOutsourceId] = useState("");
  const [helpdeskId, setHelpdeskId] = useState("");

  const [manufacturers, setManufacturers] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [outsources, setOutsources] = useState([]);
  const [helpdesks, setHelpdesks] = useState([]);

  // LOAD INITIAL DATA
  useEffect(() => {
    if (asset) {
      setManufacturerId(asset.manufacturer_id || "");
      setSupplierId(asset.supplier_id || "");
      setOutsourceId(asset.outsource_id || "");
      setHelpdeskId(asset.helpdesk_id || "");

      setManufacturers(asset.all_manufactuer || []);
      setSuppliers(asset.supplier_list || []);
      setOutsources(asset.outsource_list || []);
      setHelpdesks(asset.all_helpdesk_departments || []);
    }
  }, [asset]);

  // ON MANUFACTURER CHANGE → LOAD SUPPLIERS
  const handleManufacturerChange = async (selected) => {
    setManufacturerId(selected.manufacturer_id);

    try {
      const res = await axios.get(
        `${API_BASE_URL}/asset/suppliers/${selected.manufacturer_id}`
      );
      setSuppliers(res.data);
      setSupplierId(""); // reset selected supplier
    } catch (err) {
      console.error("Supplier fetch error:", err);
    }
  };

  // SUBMIT FORM
  const handleSave = async (e) => {
    e.preventDefault();

    const payload = {
      asset_id: asset.assets_id,

      // New Values
      manufature_id: manufacturerId,
      supplier_id: supplierId,
      outsource_id: outsourceId,
      helpdesk_id: helpdeskId,

      // Old Values (Laravel logs)
      old_manufacture: asset.manufacturer_name,
      old_supplier: asset.supplier_name,
      old_outsource: asset.outsource_name,
      old_helpdesk: asset.helpdesk_name,

      // New Log Values
      new_manufacture:
        manufacturers.find((m) => m.manufacturer_id == manufacturerId)?.manufacturer_name || "",
      new_supplier:
        suppliers.find((s) => s.supplier_id == supplierId)?.supplier_name || "",
      new_outsource:
        outsources.find((o) => o.outsource_id == outsourceId)?.outsource_name || "",
      new_helpdesk:
        helpdesks.find((d) => d.department_id == helpdeskId)?.department_name || "",
    };

    try {
      await axios.post(`${API_BASE_URL}/asset/supplier-info`, payload);

      toast.success("Supplier information updated!", {
        position: "bottom-right",
      });
    } catch (err) {
      console.error(err);
      toast.error("Update failed!", { position: "bottom-right" });
    }
  };

  return (
    <div className="card p-3">
      <h5 className="mb-3">Supplier & Manufacturer Information</h5>

      {/* FORM START */}
      <form onSubmit={handleSave}>
        <div className="row">

          {/* Manufacturer */}
          <div className="col-md-4 mb-3">
            <label>Manufacturer</label>
            <Select
              value={
                manufacturers.find((m) => m.manufacturer_id == manufacturerId) || null
              }
              onChange={handleManufacturerChange}
              options={manufacturers}
              getOptionLabel={(m) => m.manufacturer_name}
              getOptionValue={(m) => m.manufacturer_id}
              placeholder="Select Manufacturer"
              isSearchable
            />
          </div>

          {/* Supplier */}
          <div className="col-md-4 mb-3">
            <label>Supplier</label>
            <Select
              value={suppliers.find((s) => s.supplier_id == supplierId) || null}
              onChange={(selected) => setSupplierId(selected.supplier_id)}
              options={suppliers}
              getOptionLabel={(s) => s.supplier_name}
              getOptionValue={(s) => s.supplier_id}
              placeholder="Select Supplier"
              isSearchable
            />
          </div>

          {/* Outsource */}
          <div className="col-md-4 mb-3">
            <label>Outsource / Service</label>
            <Select
              value={outsources.find((o) => o.outsource_id == outsourceId) || null}
              onChange={(selected) => setOutsourceId(selected.outsource_id)}
              options={outsources}
              getOptionLabel={(o) => o.outsource_name}
              getOptionValue={(o) => o.outsource_id}
              placeholder="Select Outsource"
              isSearchable
            />
          </div>

          {/* Helpdesk */}
          <div className="col-md-4 mb-3">
            <label>Helpdesk</label>
            <Select
              value={helpdesks.find((d) => d.department_id == helpdeskId) || null}
              onChange={(selected) => setHelpdeskId(selected.department_id)}
              options={helpdesks}
              getOptionLabel={(d) => d.department_name}
              getOptionValue={(d) => d.department_id}
              placeholder="Select Helpdesk"
              isSearchable
            />
          </div>

        </div>

        <button className="btn btn-primary btn-sm mt-2" type="submit">
          Save
        </button>
      </form>
      {/* FORM END */}
    </div>
  );
};

export default SupplierInfo;
